var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","nudge-bottom":3,"content-class":_vm.contentClasses},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,{"attrs":attrs,"on":{
        mouseenter: function (e) { return _vm.onTooltip(e, on.mouseenter); },
        mouseleave: function (e) { return _vm.onTooltip(e, on.mouseleave); },
        focus: function (e) { return _vm.onTooltip(e, on.focus); },
        blur: function (e) { return _vm.onTooltip(e, on.blur); },
        keydown: function (e) { return _vm.onTooltip(e, on.keydown); },
      }})]}}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }